export const GET_PREVIOUS_CHEMPIONSHIP = 'PREVIOUS_CHEMPIONSHIP';
export const GET_LATEST_UPLOAD_THIS_WEEK = 'LATEST_UPLOAD_THIS_WEEK';
export const GET_TOP_10_THIS_WEEK = 'TOP_10_THIS_WEEK';
export const GET_TOP_10_THIS_MONTH = 'TOP_10_THIS_MONTH';
export const GET_TOP_20_TRACKS = 'TOP_20_TRACKS';
export const GET_TOP_20_ALBUMS = 'TOP_20_ALBUMS';